import { Component, inject, Input, Output } from '@angular/core';
import { deepCopy, pairs } from '@tytapp/common';
import { ComplexCondition, Condition, ConditionVariable, ContentBlocksService, LOGICAL_OPERATORS, SimpleCondition } from '@tytapp/content';
import { Subject } from 'rxjs';

const SIMPLE_TEMPLATE: SimpleCondition = {
    type: 'simple',
    variable: 'audienceType',
    operator: 'equal',
    operand: 'visitor'
};

@Component({
    selector: 'tyt-condition-editor',
    templateUrl: './condition-editor.component.html',
    styleUrl: './condition-editor.component.scss',
    standalone: false
})
export class ConditionEditorComponent {
    private contentBlocks = inject(ContentBlocksService);

    @Input() condition: ComplexCondition;

    readonly logicalOperators = pairs(LOGICAL_OPERATORS);
    readonly variables: ConditionVariable[] = this.contentBlocks.getConditionVariables();

    addSimpleSubCondition() {
        this.condition.conditions.push(deepCopy(SIMPLE_TEMPLATE));
    }

    addComplexSubCondition() {
        this.condition.conditions.push({
            type: 'complex',
            operator: 'and',
            conditions: [ deepCopy(SIMPLE_TEMPLATE) ]
        });
    }

    removeSubCondition(condition: Condition) {
        if (!confirm('Are you sure you wish to remove this condition?'))
            return;

        let index = this.condition.conditions.indexOf(condition);
        if (index < 0)
            return;

        this.condition.conditions.splice(index, 1);
    }
}
